import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ActivityFormComponent } from './activity-form/activity-form.component';
import { FormsModule } from '@angular/forms';
import { IonicStorageModule } from '@ionic/storage-angular';
import firebase from 'firebase/app';
import 'firebase/analytics';
import { TimeModule } from './pipes/time/time.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PlansMenuComponent } from './plans-menu/plans-menu.component';


var firebaseConfig = {
  apiKey: "AIzaSyCv9euuit9P6ZsVT-Hul6o5L56i7ovf-04",
  authDomain: "coach-tp.firebaseapp.com",
  projectId: "coach-tp",
  storageBucket: "coach-tp.appspot.com",
  messagingSenderId: "440323942836",
  appId: "1:440323942836:web:5f9ecb709e1f60a60a2ae1",
  measurementId: "G-GQX43ZM5P5"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();




@NgModule({
  declarations: [
    AppComponent,
    ActivityFormComponent,
    PlansMenuComponent,
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    TimeModule,
    IonicModule.forRoot(
      {
        mode: 'md',
      }
    ),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy, }],
  bootstrap: [AppComponent],
})
export class AppModule { }
